export class AdminEmails {
  carrierAdminEmail = '';
  portalAdminEmail = '';
}
